import type { Edge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge';
import { SharedState } from '@trello/shared-state';

interface StarredBoardDragAndDropState {
  boardId: string | null;
  currentClosestEdge: Edge | null;
  draggedOverBoardId: string | null;
}

const initialState: StarredBoardDragAndDropState = {
  boardId: null,
  currentClosestEdge: null,
  draggedOverBoardId: null,
};

export const starredBoardDragAndDropState =
  new SharedState<StarredBoardDragAndDropState>(initialState);

export const onDropStarredBoard = () => {
  starredBoardDragAndDropState.setValue(initialState);
};

export const isDragging = () =>
  starredBoardDragAndDropState.value.boardId !== null;
